import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteConstants } from '../shared/constants/routes.constants';
import { StorageKeys } from '../shared/enums/storage.enum';
import { StorageService } from '../services/storage/storage.service';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
    constructor(private readonly storageService: StorageService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute
    ) { }

    handleError = (error: any) => {
        if (error.status === 401 || error.statusCode === 401) {
            this.storageService.clearLocalStorage();
            this.router.navigate([RouteConstants.Login]);
        }
        return throwError(() => error);
    };

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const token = this.storageService.getDataFromLocalStorage(StorageKeys.ACCESS_TOKEN);
        const userDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
        let headers = new HttpHeaders();
        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }
        request = request.clone({ headers });
        return next.handle(request).pipe(catchError(this.handleError));
    }
}
